







import { Component, Vue } from 'vue-property-decorator';
import HeaderDev from '@/components/headers/dev-header/dev-header.vue'; // @ is an alias to /src

@Component({
  components: {
    'header-dev': HeaderDev,
  },
})
export default class AppView extends Vue {
  private mounted(){
      this.$store.dispatch('fetchParks')
  }
}
